/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Card,
  HStack,
  VStack,
  Heading,
  Link,
  Stack,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Scrollable,
  Container,
} from '@mybridge/ui';
import { forwardRef, useState } from 'react';
import { BackButton } from 'v4/components/back-button';
import {
  MyNetworkContext,
  useMyNetworkContext,
} from 'v4/components/network/context';
import NetworkPageSidebar from 'v4/components/network/network-sidebar';
import { MyNetworkPendingInvitationsListing } from 'v4/snippets/profile/manage-network/pending-invitations';
import { RemoveHandshakeRequestModal } from 'v4/snippets/profile/manage-network/remove-handshake-request-modal';
import { MyNetworkRequestsSentListing } from 'v4/snippets/profile/manage-network/requests-sent';
import { MyNetworkSuggestionsListing } from 'v4/snippets/profile/manage-network/suggestions';
import { MyNetworkManageTabs } from 'v4/snippets/profile/manage-network/tabs';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
import { useEffect } from 'react';
import MoreSuggestionsModal from 'v4/components/network/more-suggested-users-modal';
import { isMobile } from 'react-device-detect';
import MyNetworkMobile from 'v4/snippets/profile/network/mynetwork-mobile';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import style from '../../../components/header/status-dropdown/statusProfile.module.scss';
import { SiteShortcutLinks } from 'v4/snippets/dashboard/site-shortcut-links';
import { DashboardMyCircle } from 'v4/snippets/dashboard/circle';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

const MyProfileManageConnectionsPage = forwardRef(({ ...props }, ref) => {
  const { loggedIn } = useSelector((state) => state.user);
     const { userProfileInfo } = useSelector((state) => state.userProfile);
  
  const { globalNotifCount } = useSelector((state) => state.notifications);
  /*
  const networkContext = useMyNetworkContext({});
  */
  const networkContext = useMyNetworkContext({
    refetchSuggestionsEnabled: true,
  });
  
  const userSlug =userProfileInfo?.slug ||'';

  const {
    tabs,
    activeTab,
    removeHandshakeRequestDisc,
    pendingInvitations,
    requestsSent,
    refetchBlocked,
    blocked,
    moreSuggestionModalDisc,
  } = networkContext ?? {};
  const { t } = useTranslator();
  const [isShowAllActive, setIsShowAllActive] = useState(false);

  useEffect(() => {
    trackEvent(ANALYTICS_EVENTS.Invitations, userSlug);
  }, [userSlug]);
  
  /*
  useEffect(() => {
    refetchBlocked?.();
  }, []);
  */

  return (
    <AuthenticatedProviders>
      <Head>
        <title>
          {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}{' '}
          {t('navigation.myNetwork') || 'myNetwork'} | myBridge.me
        </title>
      </Head>
      <MyNetworkContext.Provider value={networkContext}>
        {isMobile ? (
          <MyNetworkMobile />
        ) : (
          <Stack
            spacing={4}
            alignItems="flex-start"
            direction={['column', 'row']}
            // minH={!isMobile && '120vh'}
            minH={['auto', 'auto', '100vh']}
          >
            <Stack
              display={['none', 'none', 'flex']}
              position="sticky"
              top="64px"
              spacing={2}
              // bg="white"
              // boxShadow="2px 0px 6px 0px #00000033"
              minH="90vh"
              borderBottom="1px solid #e0e0e094"
              height={'500px'}
              zIndex="999"
              className={style.leftTeams}
            >
              <SiteShortcutLinks />

              <Box className={style.hideTitle}>
                <DashboardMyCircle h="300px" flex="1" />
              </Box>
            </Stack>
            {isMobile ? (
            <Scrollable pos="sticky" top="64px" maxH="calc(100vh-64px)">
              <NetworkPageSidebar isActive={'manage'} />
            </Scrollable>
             ) : (
              <VStack pos="sticky" top="64px" maxH="400px">
                <NetworkPageSidebar isActive={'manage'} />
              </VStack>
            )}
            <Stack
              pl="100px"
              w={['100%', '65%', '100%']}
              justifyContent="center"
              mb={5}
            >
              <Container p={1} maxW="100%">
                <Box p={[0, 1, 1]} pt={[3, 4, 4]} mb={3}>
                  <Heading
                    fontSize="20px"
                    color="brandPrimary.500"
                    mb={3}
                    fontWeight="400"
                  >
                    {t('profileNetwork.invitations') || "Invitations"}
                  </Heading>
                  <Tabs index={tabs?.findIndex?.((t) => t.name === activeTab)}>
                    <TabList border="none">
                      <MyNetworkManageTabs />
                    </TabList>
                    <TabPanels>
                      <TabPanel p={0} py={3}>
                        <MyNetworkPendingInvitationsListing
                          from='pending-invite'
                          onShowAll={setIsShowAllActive}
                        />
                      </TabPanel>
                      <TabPanel p={0} py={3}>
                        <MyNetworkRequestsSentListing
                          from='sent-invite'
                          onShowAll={setIsShowAllActive}
                        />
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                </Box>
                {!isShowAllActive && <MyNetworkSuggestionsListing />}
              </Container>
            </Stack>
          </Stack>
        )}

        {removeHandshakeRequestDisc?.isOpen ? (
          <RemoveHandshakeRequestModal {...removeHandshakeRequestDisc} />
        ) : (
          ''
        )}

        {moreSuggestionModalDisc?.isOpen && <MoreSuggestionsModal />}
      </MyNetworkContext.Provider>
    </AuthenticatedProviders>
  );
});
export default MyProfileManageConnectionsPage;
